import { render, staticRenderFns } from "./MailTable.vue?vue&type=template&id=6b20df92"
import script from "./MailTable.vue?vue&type=script&lang=js"
export * from "./MailTable.vue?vue&type=script&lang=js"
import style0 from "./MailTable.vue?vue&type=style&index=0&id=6b20df92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@3.1.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports